import request from '../../axios';
import {ICreateOrderCardToCardTransactionPayload} from './types';

const postPaymentOrderCardToCardTransaction = async (
  payload: ICreateOrderCardToCardTransactionPayload,
) => {
  const formData = new FormData();
  formData.append('order', payload?.order);
  formData.append('image', payload?.image);
  formData.append('payment_type', payload?.payment_type.toString());

  const {data} = await request.post(
    `/api/v2/payment/payment-order-transaction-card-to-card`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );
  return data;
};

export default postPaymentOrderCardToCardTransaction;
